import { default as CIcon, CIconWarn } from './CIcon';
export default CIcon;
export { CIconWarn as CIcon, CIconWarn as CIconRaw };